export default {"src":"/shop/_next/static/media/pause.255be10c.svg","height":485,"width":485,"blurWidth":0,"blurHeight":0};